import React from 'react';

import PageHeader from "../components/gamePlayComponents/PageHeader";

const Rules = () => {
const mt= '16px';
  return (
    <>
      <PageHeader goBack title={'Rules'}/>
      <ol style={{lineHeight: '1.3'}}>
        <li style={{marginTop: mt}}>Only use your observation to answer clues. Don't use Google to get answers or get closer to solving clues.</li>
        <li style={{marginTop: mt}}>Do not try and game the score by guessing on one device until you find the right answer only to enter the right answer on another device for a perfect score.</li>
      </ol>
    </>
  )
};

export default Rules;